<template>
  <div class="news-list-component" ref="newsList">
    <div class="area">
      <div class="row news-list-container" v-animated-show="utils.handleScroll">
        <h1 v-html="title" class="float-title col-9"></h1>
        <section
          class="list-section-banner"
          v-for="(l, i) in list"
          ref="news"
          :key="i"
          :class="[
            l.column ? 'first' : 'second',
            {
              'with-image': i % 5 == 4,
              greyscale: greyscale[i],
            },
          ]"
        >
          <div class="content">
            <!-- <div class>
              column = {{ l.column ? "first" : "second" }}, index = {{ i }},
              l.index = {{ l.index }}
                        </div>-->
            <Description
              class
              :class="[l.tagColor, i === 0 ? 'default' : 'mini']"
              ref="bannerDescription"
              :isMoreTop="true"
              :title="l.title"
              :desc="l.desc"
              :more="'#' + l.tag + '—' + l.date"
              :button="'Подробнее'"
              :href="l.href"
              :icon="l.icon"
              v-if="l.title"
            />
          </div>
          <div class="art-img" v-if="i % 5 == 4">
            <img :src="l.img.src" :alt="l.img.alt" class="art" />
          </div>
        </section>
        <ScrollMarker
          @scrolled="
            e => {
              onChange(e);
            }
          "
        />
        <a
          v-if="haveMore"
          href="/"
          @click.prevent="
            () => {
              showMore();
            }
          "
          class="button-load-more"
        >
          <div class="button nav-arrow nav-arrow--prev"></div>
          <span>{{ button }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ScrollMarker from "../components/ScrollMarker";
import utils from "../utils";
export default {
  name: "NewsList",
  props: {
    title: String,
    button: String,
    list: Array,
    haveMore: Boolean,
  },
  data() {
    return {
      utils: utils,
      greyscale: [],
      currentY: 0,
    };
  },
  watch: {
    list() {
      this.updateColumns();
    },
  },
  methods: {
    showMore() {
      this.$emit("loadmore");
    },
    onChange(currentY) {
      this.currentY = currentY;
    },
    onScroll() {
      this.$refs.news.forEach((element, index) => {
        let top = element.getBoundingClientRect().top;
        this.greyscale[index] = top > this.currentY && index !== 0;
      });
      this.greyscale = [...this.greyscale];
    },
    updateColumns() {
      var i = 0;
      this.list.forEach((element, index) => {
        this.greyscale.push(i != 0);
        switch (element.tag) {
          case "новость":
            element.tagColor = "color-red";
            break;
          case "анонс":
            element.tagColor = "color-blue";
            break;
          case "предложение":
            element.tagColor = "color-cyan";
            break;
        }
        element.column = i % 2 === 0;
        if (index % 5 === 4) {
          i += 2;
        } else {
          i += 1;
        }
      });
    },
  },
  beforeDestroy() {
    if (document.getElementById("page-container")) {
      document
        .getElementById("page-container")
        .removeEventListener("scroll", this.onScroll);
    }
  },
  mounted() {
    document
      .getElementById("page-container")
      .addEventListener("scroll", this.onScroll);
    this.updateColumns();
  },
  components: { ScrollMarker },
};
</script>

<style lang="scss">
.news-list-component {
  @extend %page-block;
  .float-title {
    @media all and (max-width: $md) {
      margin-top: 0;
      margin-bottom: 70px;
    }
    @extend %float-title;
    margin-right: 30%;
  }
  .news-list-container {
    @media all and (max-width: $md) {
      grid-row-gap: 36px;
    }
    grid-row-gap: 100px;
  }
  .list-section-banner {
    transition: color 0.5s;
    grid-column: span 3;
    &:nth-child(2) {
      @media all and (max-width: $md) {
        margin-top: -40px;
      }
    }
    .more {
      transition: color 0.5s;
    }
    .description.mini {
      .description-content {
        grid-gap: 18px;
      }
      .desc {
        margin-top: -5px;
        line-height: 1.33em;
      }
    }
    &.greyscale {
      @media all and (max-width: $md) {
        color: unset;
      }
      color: $bg-grey-dark2;
      .more {
        @media all and (min-width: $md + 1px) {
          color: $bg-grey-dark2 !important;
        }
      }

      &.with-image {
        .art-img {
          @media all and (max-width: $md) {
            filter: unset;
            -webkit-filter: unset;
            -moz-filter: unset;
            -ms-filter: unset;
            -o-filter: unset;
            filter: unset;
          }
          filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
          filter: gray;
        }
      }
    }
    &:nth-child(2) {
      @media all and (max-width: $md) {
        grid-column: 1 / span 12 !important;
        margin-right: 0 !important;
      }
      grid-column: 1 / span 5 !important;
      grid-row: 2 !important;
      margin-right: 26px !important;
      margin-left: 0;
    }

    &.first {
      @media all and (max-width: $md) {
        grid-column: 1 / span 12;
        margin-right: unset;
      }
      grid-column: 6 / span 3;
      margin-right: -26px;
    }
    &.second {
      @media all and (max-width: $md) {
        margin-left: unset;
        grid-column: 1 / span 12;
      }
      grid-column: 10 / span 3;
      margin-left: -26px;
    }
    &.with-image {
      @media all and (max-width: $md) {
        grid-column: 1 / span 12;
        display: unset;
      }
      grid-column: 6 / span 7;
      display: grid;
      grid-gap: 26px;
      grid-template-columns: repeat(7, minmax(0, 1fr));
      margin-right: 0;
      margin-left: 0px;
      .content {
        @media all and (max-width: $md) {
          grid-column: 1 / span 12;
          margin-right: unset;
        }
        grid-column: 1 / span 3;
        margin-right: -26px;
      }
      .art-img {
        @media all and (max-width: $md) {
          margin: 30px 0 0 0;
        }
        transition: filter 0.5s;
        grid-column: 5 / span 3;
        margin-left: -26px;
        align-self: stretch;
        display: grid;
        margin-top: -30px;
        margin-bottom: -30px;
        img {
          @media all and (max-width: $md) {
            mask-position: center center;
            height: 331px;
            width: 100%;
          }
          object-fit: cover;
          align-self: stretch;
          mask: url(../assets/photos/news/news_mask.svg) no-repeat;
          mask-size: contain;
        }
      }
    }
    .color-red {
      .more {
        color: #e6332a;
      }
    }
    .color-blue {
      .more {
        color: #29235c;
      }
    }
    .color-cyan {
      .more {
        color: #00a19a;
      }
    }
    .default {
      .title {
        @media all and (max-width: $md) {
          font-size: 18px;
        }
      }
      .desc {
        @media all and (max-width: $md) {
          font-size: 12px;
        }
      }
      .more {
        @media all and (max-width: $md) {
          font-size: 12px;
          font-weight: bold;
        }
        @extend %text-h4;
        font-weight: bold;
        font-size: 16px;
      }
    }
    .mini {
      .more {
        @extend %text-h5;
        font-weight: bold;
        font-size: 12px;
      }
    }
  }
  .button-load-more {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
    }
    grid-column: 6 / span 7;
    justify-self: center;
    justify-items: center;
    display: grid;
    grid-gap: 15px;
    @extend %text-h5;
    .button {
      width: 42px;
      &::before {
        transform: rotate(-90deg);
      }
    }
    span {
    }
    transition: color 0.5s;
    color: $text-main-quart;

    &:hover {
      border-color: transparent;
      color: $text-main;
      .button {
        background: $color-accent;
        &::before {
          color: $text-inverse-main;
        }
      }
    }
  }
  .scroll-marker {
    @media all and (max-width: $md) {
      display: none;
    }
    top: 300px;
    position: absolute;
    bottom: -54px;
    grid-column: 6;
    margin-left: -27px;
  }
}

.mac {
  .news-list-component {
    .scroll-marker {
      margin-left: -36px;
    }
  }
}
</style>
